import { z } from 'zod';

/**
 * Enforces only the public variables the sessions app needs to boot. `.env.README`
 * documents all variables and how local and deployed builds load them.
 */
const schema = z.object({
  // The graphql HTTP + WS endpoints the urql client targets. Required: without
  // them the client used to build requests against `undefined/graphql` and fail
  // opaquely at runtime. `NEXT_PUBLIC_GRAPHQL_URL` is the base (the client
  // appends `/graphql`); `NEXT_PUBLIC_GRAPHQL_WS_URL` is the full ws endpoint.
  NEXT_PUBLIC_GRAPHQL_URL: z.string().url(),
  NEXT_PUBLIC_GRAPHQL_WS_URL: z.string().url(),
});

// Each `process.env.NEXT_PUBLIC_*` MUST be referenced statically here so Next
// inlines the literal into the client bundle at build time. Spreading
// `process.env` or reading via a computed key silently breaks inlining and the
// value arrives `undefined` in the browser.
const parsed = schema.safeParse({
  NEXT_PUBLIC_GRAPHQL_URL: process.env.NEXT_PUBLIC_GRAPHQL_URL,
  NEXT_PUBLIC_GRAPHQL_WS_URL: process.env.NEXT_PUBLIC_GRAPHQL_WS_URL,
});

if (!parsed.success) {
  const details = parsed.error.issues.map(issue => `  - ${issue.path.join('.')}: ${issue.message}`).join('\n');
  throw new Error(
    `Invalid sessions environment:\n${details}\n\nSet these locally in .env.local — see apps/sessions/.env.README.`,
  );
}

export const env = parsed.data;
